(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-premium"] && !Shopify.designMode) return;
  try {
    
function initLaCancha(root) {
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const products=[...root.querySelectorAll('[data-product-id]')];
  const saved=new Set();
  const productDialog=root.querySelector('[data-product-dialog]');
  const selectionDialog=root.querySelector('[data-selection-dialog]');
  const ageFilter=root.querySelector('[data-age-filter]');
  const filterStatus=root.querySelector('[data-filter-status]');
  let category='all',currentProduct=null,toastTimer;
  const toast=root.querySelector('[data-toast]');
  const productById=id=>products.find(p=>p.dataset.productId===id);
  const titleOf=p=>p.querySelector('h3').textContent.trim();
  function announce(message){clearTimeout(toastTimer);toast.textContent=message;toast.classList.add('is-visible');toastTimer=setTimeout(()=>toast.classList.remove('is-visible'),2400);}
  function filter(){let count=0;products.forEach(p=>{const visible=(category==='all'||p.dataset.productCategory===category)&&(ageFilter.value==='all'||p.dataset.productAudiences.split(',').map(a=>a.trim()).includes(ageFilter.value));p.hidden=!visible;if(visible)count++;});filterStatus.textContent=filterStatus.dataset.countTemplate.replace('[count]',String(count));root.querySelector('[data-no-results]').hidden=count>0;}
  function updateSave(){root.querySelectorAll('[data-selection-count]').forEach(el=>el.textContent=String(saved.size));root.querySelectorAll('[data-save]').forEach(b=>b.setAttribute('aria-pressed',String(saved.has(b.dataset.save))));const b=root.querySelector('[data-dialog-save]');b.textContent=currentProduct&&saved.has(currentProduct)?b.dataset.labelSaved:b.dataset.labelSave;b.setAttribute('aria-pressed',String(!!currentProduct&&saved.has(currentProduct)));}
  function toggleSave(id){if(!productById(id))return;if(saved.has(id)){saved.delete(id);announce(toast.dataset.labelRemoved);}else{saved.add(id);announce(toast.dataset.labelAdded);}updateSave();if(selectionDialog.open)renderSelection();}
  function openProduct(id){const p=productById(id);if(!p)return;currentProduct=id;root.querySelector('#lc-dialog-title').textContent=titleOf(p);root.querySelector('[data-dialog-category]').textContent=p.querySelector('.lc-product-category').textContent;root.querySelector('[data-dialog-color]').replaceChildren(...p.querySelector('.lc-product-color').cloneNode(true).childNodes);const img=p.querySelector('img').cloneNode();img.removeAttribute('sizes');img.removeAttribute('srcset');img.loading='eager';root.querySelector('[data-dialog-image]').replaceChildren(img);root.querySelector('[data-dialog-description]').replaceChildren(p.querySelector('template').content.cloneNode(true));updateSave();productDialog.showModal();}
  function renderSelection(){const container=root.querySelector('[data-selection-items]');container.replaceChildren();saved.forEach(id=>{const p=productById(id);const row=document.createElement('div');row.className='lc-selection-row';const img=p.querySelector('img').cloneNode();img.sizes='68px';const name=document.createElement('span');name.textContent=titleOf(p);const remove=document.createElement('button');remove.type='button';remove.textContent='×';remove.setAttribute('aria-label',toast.dataset.labelRemoved+' '+titleOf(p));remove.addEventListener('click',()=>toggleSave(id));row.append(img,name,remove);container.append(row);});root.querySelector('[data-selection-empty]').hidden=saved.size>0;root.querySelector('[data-copy-selection]').disabled=saved.size===0;root.querySelector('[data-copy-status]').textContent='';}
  root.querySelectorAll('[data-category]').forEach(b=>b.addEventListener('click',()=>{category=b.dataset.category;root.querySelectorAll('[data-category]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));filter();}));
  ageFilter.addEventListener('change',filter);
  function resetCategory(){category='all';root.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category==='all')));}
  root.querySelector('[data-reset-filters]').addEventListener('click',()=>{resetCategory();ageFilter.value='all';filter();});
  root.querySelectorAll('[data-generation]').forEach(a=>a.addEventListener('click',()=>{resetCategory();ageFilter.value=a.dataset.generation;filter();}));
  root.querySelectorAll('[data-open-product]').forEach(b=>b.addEventListener('click',()=>openProduct(b.dataset.openProduct)));
  root.querySelectorAll('[data-save]').forEach(b=>b.addEventListener('click',()=>toggleSave(b.dataset.save)));
  root.querySelector('[data-dialog-save]').addEventListener('click',()=>toggleSave(currentProduct));
  root.querySelector('[data-open-selection]').addEventListener('click',()=>{renderSelection();selectionDialog.showModal();});
  root.querySelectorAll('[data-close-dialog]').forEach(b=>b.addEventListener('click',()=>b.closest('dialog').close()));
  root.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}}));
  root.querySelector('[data-copy-selection]').addEventListener('click',async e=>{const b=e.currentTarget;const text='LA CANCHA · '+root.querySelector('#lc-selection-title').textContent+'\n'+[...saved].map(id=>'— '+titleOf(productById(id))).join('\n');try{await navigator.clipboard.writeText(text);root.querySelector('[data-copy-status]').textContent=b.dataset.labelCopied;}catch{root.querySelector('[data-copy-status]').textContent=b.dataset.labelError;}});
  const menu=root.querySelector('.lc-menu-toggle'),nav=root.querySelector('.lc-mobile-nav');
  const closeMenu=()=>{menu.setAttribute('aria-expanded','false');nav.hidden=true;};
  menu.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')==='true';menu.setAttribute('aria-expanded',String(!open));nav.hidden=open;});
  nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
  root.addEventListener('keydown',e=>{if(e.key==='Escape')closeMenu();});
  filter();updateSave();
}
document.querySelectorAll('[data-lc-premium]').forEach(initLaCancha);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-lc-premium]').forEach(initLaCancha));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-validation"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('.lc-validation');
  if (!root || root.dataset.live !== 'true') return;
  const form = root.querySelector('#LcInterestForm');
  if (!form) return;
  const publish = async (eventName, extra = {}) => {
    try {
      if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return false;
      if (typeof window.Shopify?.analytics?.publish !== 'function') return false;
      const result = await window.Shopify.analytics.publish(eventName, {experiment_id:'lc01-v1',product_id:'camiseta',currency:'EUR',offer_total_eur:34.80,...extra});
      return result !== false;
    } catch { return false; }
  };
  let offerVisible = false;
  let offerPublished = false;
  let offerPublishing = false;
  const publishOffer = async () => {
    if (!offerVisible || offerPublished || offerPublishing || document.visibilityState !== 'visible') return;
    offerPublishing = true;
    offerPublished = await publish('lc_offer_viewed');
    offerPublishing = false;
    if (offerPublished) observer.disconnect();
  };
  const observer = new IntersectionObserver((entries) => {
    offerVisible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.5);
    void publishOffer();
  }, {threshold:0.5});
  const offer = root.querySelector('.lc-offer-copy');
  if (offer) observer.observe(offer);
  document.addEventListener('visitorConsentCollected', publishOffer);
  document.addEventListener('visibilitychange', publishOffer);
  form.addEventListener('submit', (event) => {
    const size = form.querySelector('[data-lc-size]').value;
    const intent = form.querySelector('[data-lc-intent]').value;
    const zone = form.querySelector('[data-lc-zone]').value;
    if (!['XS','S','M','L','XL','XXL'].includes(size) || !['price-accepted','sample-first','story-only'].includes(intent) || !['es-mainland','other'].includes(zone)) { event.preventDefault(); return; }
    form.querySelector('[data-lc-tags]').value = ['newsletter','lc01-v1','lc-product-camiseta','lc-total-34-80','lc-size-'+size.toLowerCase(),'lc-intent-'+intent,'lc-zone-'+zone,'lc-consent-v1'].join(',');
    void publish('lc_signup_attempt', {size,intent,zone});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
